export default __webpack_public_path__ + "static/media/checked.73fb4fb1.svg";